<template>
  <div>
    <Card>
      <ui-menu
        v-model="showContextMenu"
        :has-triangle="true"
        location="bottom start"
        :offset="[100, 40]"
        :items="menuList"
        :menu-props="{
          menuWidth: 188,
        }"
      >
        <template #activator="{ props: activatorProps }">
          <ui-button
            v-bind="activatorProps"
            text="Activator"
            :open="showContextMenu"
            @click.stop="showContextMenu = !showContextMenu"
          ></ui-button>
        </template>
      </ui-menu>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

import { ref } from 'vue';

const showContextMenu = ref(false);

const menuList = [
  {
    key: '1',
    title: 'test1',
    icon: 'far fa-pen',
  },
  {
    key: '2',
    title: 'test2',
    icon: 'far fa-pen',
  },
];
</script>
